module.exports = __webpack_public_path__ + "static/media/11.b1a8a63e.jpg";